'use strict';

import { List } from './list.js';

export class ListMyadsstatus extends List {
	add_events() {
		this.$root.on('click', '.js-myads_phone_website_plp_trigger', (e) => {
			e.preventDefault();
			const dialog = yalwa.v?.components?.initialized?.dialog_myadsphonewebsitedialog;
			if (dialog) dialog.show();
		});
	}
}
